// latest: zhangmyh 2017-4-5 10:57 AM
/* global $ u */

let _collection
let getButtonText = (type) => {
  if (type == 1) {
    return '≤'
  } else {
    return '<'
  }
}

let changeinclude = function (row, type, ele) {
  let v = (row.getValue(type)) ? 0 : 1
  row.setValue(type, v)
  $(ele).text(getButtonText(v))
}

function init (refer) {
  let vm = {
    changemin: function (row, e) {
      changeinclude(row, 'includeMin', e.target)
    },
    changemax: function (row, e) {
      changeinclude(row, 'includeMax', e.target)
    },
    getButtonText,
    model: _collection
  }
  let app = u.createApp()
  app.init(vm, $('#refer_standard')[0])
}

let template = require('./index.html')
export default function (collection) {
  _collection = collection
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/evaStandard/index.js